import { render, staticRenderFns } from "./PainPointPicker.vue?vue&type=template&id=790cde17&scoped=true&"
import script from "./PainPointPicker.vue?vue&type=script&lang=js&"
export * from "./PainPointPicker.vue?vue&type=script&lang=js&"
import style0 from "./PainPointPicker.vue?vue&type=style&index=0&id=790cde17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790cde17",
  null
  
)

export default component.exports